import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdPopup.css";
import adImage from "../assets/detty-december.jpeg";

export default function AdPopup() {
  const [isVisible, setIsVisible] = useState(false); // popup visibility
  const [imageLoaded, setImageLoaded] = useState(false); // track image load
  const navigate = useNavigate();

  useEffect(() => {
    // Show popup after 1s **and** image has loaded
    const timer = setTimeout(() => {
      if (imageLoaded) {
        setIsVisible(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [imageLoaded]);

  // Preload the image
  useEffect(() => {
    const img = new Image();
    img.src = adImage;
    img.onload = () => setImageLoaded(true);
  }, []);

  if (!isVisible) return null;

  const handleBookNow = () => {
    setIsVisible(false);
    navigate("/detty-december");
  };

  return (
    <div className="ad-popup-overlay">
      <div className="ad-popup">
        <button className="ad-popup-close" onClick={() => setIsVisible(false)}>
          &times;
        </button>

        <img
          src={adImage}
          alt="Detty December Promo"
          className="ad-popup-image"
        />

        <button
          className="ad-popup-button post-review-btn"
          onClick={handleBookNow}
        >
          Book Now
        </button>
      </div>
    </div>
  );
}
